import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { ToCloseAllContext } from '../../Layout';
import "../../style.css";
import "./WorkSection.css";
import CardMedia from '@mui/material/CardMedia';
import {Button} from '@mui/base';
import {Modal} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import debounce from "lodash.debounce";

function WorkSection(props) {
    const [open, setOpen] = useState(false);
    const [initialized, setInitialized] = useState(false);
    const [beingKilled, setBeingKilled] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [videoOpen, setVideoOpen] = useState(false);
    const workRow2Ref = useRef(null);
    const workSectionRef = useRef(null);
    const workDescRef = useRef(null);

    // const { toCloseAll, setToCloseAll } = useContext(ToCloseAllContext);

    const images = props.images || [props.img];

    // function onToggle() {
    //     setOpen(!open);
    // }

    const handleTarget = (offset = 0) => {
        // if (!open) return;
        const headerOffset = offset;
        const elementPosition = workSectionRef.current.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    const handleClickOpen = () => {
        const workRow2Element = workRow2Ref.current;
        const workDescElement = workDescRef.current;
        workRow2Element.style.height = '0px';
        workDescElement.style.maxHeight = `${workDescElement.scrollHeight}px`;
        requestAnimationFrame(() => {
            workRow2Element.style.height = `${workRow2Element.scrollHeight}px`;
            workDescElement.style.maxHeight = '0px';
        });
        setOpen(true);
    };

    const handleClickClose = (killed=false) => {
        // if (beingKilled) {
        //     document.body.classList.add('no-animation');
        // }
        const workRow2Element = workRow2Ref.current;
        const workDescElement = workDescRef.current;
        workRow2Element.style.height = `${workRow2Element.scrollHeight}px`;
        workDescElement.style.maxHeight = '0px';
        requestAnimationFrame(() => {
            workRow2Element.style.height = '0px';
            workDescElement.style.maxHeight = `${workDescElement.scrollHeight}px`;
        });
        // if (killed) {
        //     setBeingKilled(true);
        // }
        setOpen(false);
    };

    // const handleImageClick = (event) => {
    //     const {left, width} = event.target.getBoundingClientRect();
    //     const clickX = event.clientX - left;
    //     if (clickX < width / 3) {
    //         setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    //     } else if (clickX > width * 2 / 3) {
    //         setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    //     } else {
    //         handleClickClose();
    //     }
    // };

    // const handleMouseMove = (event) => {
    //     const {left, width} = event.target.getBoundingClientRect();
    //     const mouseX = event.clientX - left;
    //     if (mouseX < width / 3) {
    //         event.target.classList.add('left-arrow');
    //         event.target.classList.remove('right-arrow');
    //         event.target.classList.remove('pointer');
    //     } else if (mouseX > width * 2 / 3) {
    //         event.target.classList.add('right-arrow');
    //         event.target.classList.remove('pointer');
    //         event.target.classList.remove('left-arrow');
    //     } else {
    //         event.target.classList.add('pointer');
    //         event.target.classList.remove('left-arrow');
    //         event.target.classList.remove('right-arrow');
    //     }
    // };

    useEffect(() => {
        const workRow2Element = workRow2Ref.current;
        const workDescElement = workDescRef.current;
        if (open) {
            const handleTransitionEnd = () => {
                workRow2Element.style.height = 'auto';
                workDescElement.style.maxHeight = '0px';
                workRow2Element.removeEventListener('transitionend', handleTransitionEnd);
            };
            workRow2Element.addEventListener('transitionend', handleTransitionEnd);
            document.documentElement.classList.add('no-scroll');
            // setToCloseAll(false);
            handleTarget(0);
        } else {
            if (initialized) {
                const handleTransitionEnd = () => {
                    workRow2Element.style.height = '0px';
                    workDescElement.style.maxHeight = 'fit-content';
                    workRow2Element.removeEventListener('transitionend', handleTransitionEnd);
                };
                workRow2Element.addEventListener('transitionend', handleTransitionEnd);
                document.documentElement.classList.remove('no-scroll');
                // if (!beingKilled) {
                // document.body.classList.remove('no-animation');
                // }
                handleTarget(240);
            } else {
                setInitialized(true);
            }
        }
    }, [open]);

    const handleResize = () => {
        if (open) {
            // handleClickClose();
            console.log('resize');
            if (workSectionRef) {
                workSectionRef.current.scrollIntoView({ behavior: 'instant'});
            }
        }
    };

    // useEffect(() => {
    //     if (toCloseAll && open) {
    //         handleClickClose(true);
    //         setToCloseAll(false);
    //     }
    // }, [toCloseAll]);

    window.addEventListener('resize', handleResize);
    const navLinks = document.querySelectorAll('.nav-text');
    navLinks.forEach(link => {
            link.addEventListener('click', handleClickClose);
        }
    );

    // the closer the mouse is to close-button, the larger the close-button is
    const handleMouseApproach = (event) => {
        // const closeButton = document.querySelector('.close-button');
        const ball1 = document.querySelector('.ball-1');
        const ball2 = document.querySelector('.ball-2-under');
        if (!ball2) return;
        const {left, top, width, height} = ball1.getBoundingClientRect();
        const centerX = left + width / 2;
        const centerY = top + height / 2;
        const {clientX, clientY} = event;
        const distance = Math.sqrt(Math.pow(clientX - centerX, 2) + Math.pow(clientY - centerY, 2));
        // const scale = Math.max(1, 2 - distance / 600);
        // closeButton.style.transform = `scale(${scale})`;

        const ball2s = document.querySelectorAll('.ball-2');

        if (distance > 120) {
            const translate = Math.max(0, 21 - distance / 35);
            ball2s.forEach(ball2 => {
                ball2.style.left = `${translate}px`;
                // ball2.style.top = null;
                ball2.style.bottom = `${translate}px`;
                // ball2.style.translate = null;
            });
        } else {
            ball2s.forEach(ball2 => {
                // ball2.style.left = `${event.clientX}px`;
                // ball2.style.top = `${event.clientY}px`;
                ball2.style.left = `22px`;
                ball2.style.bottom = `22px`;
                // ball2.style.translate = `-50% -50%`;
            });
        }
    }

    const throttle = (func, delay) => {
        let lastCall = 0;
        return function (...args) {
            const now = new Date().getTime();
            if (now - lastCall < delay) return;
            lastCall = now;
            return func(...args);
        };
    };

    const throttledMouseApproach = useCallback(
        throttle(handleMouseApproach, 50), // 50毫秒的节流时间
        []
    );

    useEffect(() => {
        window.addEventListener('mousemove', throttledMouseApproach);
        return () => {
            window.removeEventListener('mousemove', throttledMouseApproach);
        };
    }, [throttledMouseApproach]);

    const handleVideoOpen = () => {
        setVideoOpen(true);
    };

    const handleVideoClose = () => {
        setVideoOpen(false);
    };

    // const isIframe = (url) => url.startsWith('http');

    return (
        <>
            <div ref={workSectionRef} id={props.id}
                 className={"work-section " + props.className + (open ? " work-section-open" : "")}>
                <div className={"work-row work-row-1"}>
                    <div className={"flex0 flex_col work-left" + (open ? " work-left-open" : "")}>
                        <div className={"work-title flex0 flex_col" + (open ? " work-title-open" : "")}>
                            <div className={"work-title-year flex0"}>{props.year}</div>
                            <div className={"work-title-name flex0" + (open ? " " : " pointer")}
                                 onClick={open ? null : handleClickOpen}>
                                <span className={open ? "" : "work-title-span"}>{props.title}</span>
                            </div>
                            <div ref={workDescRef}
                                 className={"work-desc-segment flex1" + (open ? " work-desc-segment-open" : " work-desc-segment-close")}>
                                {props.desc.map((item, index) => {
                                    return (
                                        <div key={"work-desc-" + index} className={"work-desc-line"}>{item}</div>
                                    )
                                })}
                            </div>
                        </div>
                        <div className={"work-desc flex1 flex_row" + (open ? " work-desc-open" : "")}>
                            <div className={"work-type-text flex2 flex_col"}>
                                <div
                                    className={"flex0 flex_col work-type-block" + (open ? " work-type-block-open" : "")}>
                                    {props.type.map((item, index) => {
                                        return (
                                            <div key={"work-type-" + index} className={"work-type-line"}>{item}</div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"work-content flex_col" + (open ? " work-right-open" : " work-right-close")}>
                        <div className={"work-img-container" + (open ? " " : " pointer")}
                             onClick={open ? null : handleClickOpen}
                            // onMouseMove={open ? handleMouseMove : null}
                        >
                            <CardMedia component={"img"} alt={props.title}
                                       image={images[currentImageIndex]}
                                       className={"work-img"}/>
                        </div>
                    </div>
                </div>
                <div ref={workRow2Ref} className={"work-row-2 work-row" + (open ? " work-row-2-open" : "")}>
                    <div className={"flex1 flex_col work-empty"}>
                        <table className={"work-detail-right-right"}>
                            <tbody>
                            <tr>
                                <th>Role</th>
                            </tr>
                            <tr>
                                <td>{props.role.join(" / ")}</td>
                            </tr>
                            <tr>
                                <th>Tech Stack</th>
                            </tr>
                            <tr>
                                <td>{props.tech.join(" / ")}</td>
                            </tr>
                            <tr>
                                {props.live &&
                                    <th>
                                        <Button className={"demo-button button"} href={props.live} target={"_blank"}
                                                rel="noreferrer">Live Demo</Button>
                                    </th>
                                }
                                {props.video &&
                                    <th>
                                        <div className={"demo-button button"} onClick={handleVideoOpen}>Video Demo</div>
                                    </th>
                                }
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className={"work-detail flex1 flex_col" + (open ? " work-right-open" : " work-right-close")}>
                        <div className={"flex1 work-detail-left flex_col work-detail-col flex_col"}>
                            {props.text && props.text.map((item, index) => {
                                    return (
                                        <div className={"work-detail-section w-100"} key={"work-detail-section-" + index}>
                                            {item.heading &&
                                                <div key={"work-detail-heading-" + index}
                                                     className={"work-detail-heading"}>{item.heading}</div>}
                                            {item.text && <div key={"work-detail-text-" + index}
                                                               className={"work-detail-text"}>{item.text.split("**").map((part, i) =>
                                                i % 2 === 1 ?
                                                    <span key={i}
                                                          className={"work-detail-bold"}>{part}</span> : part)}</div>}
                                            {item.list && (
                                                <ul className={"work-detail-list"}>
                                                    {item.list.map((listItem, listIndex) => (
                                                        <li key={"work-detail-list-" + index + "-" + listIndex}>
                                                            {listItem.heading && <span
                                                                key={"work-detail-list-heading-" + index + "-" + listIndex}
                                                                className={"work-detail-list-heading"}>{listItem.heading}: </span>}
                                                            <span key={"work-detail-list-text-" + index + "-" + listIndex}
                                                                  className={"work-detail-list-text"}>{listItem.text}</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                            {item.image && (
                                                <div key={"work-detail-image-" + index}
                                                     className={"work-detail-img"}>
                                                    <CardMedia component={"img"} alt={props.title}
                                                               image={item.image}/>
                                                </div>
                                            )}
                                        </div>
                                    )
                                }
                            )}
                        </div>
                        {/*<div className={"flex1"}></div>*/}
                        {/*<div className={"flex0 work-detail-right work-detail-col"}>*/}
                        {/*</div>*/}
                        {/*<div className={"flex1"}></div>*/}
                    </div>
                </div>
                {videoOpen && (
                    <Modal
                        open={videoOpen}
                        onClose={handleVideoClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                        className={"video-modal"}
                    >
                        <div className={"video-modal-container"}>
                            {/*<div className="video-modal-content">*/}
                            <iframe src={props.video} frameBorder="0" allow="autoplay; fullscreen" title={props.title}
                                    allowFullScreen></iframe>
                            {/*</div>*/}
                            <div className="video-modal-close" onClick={handleVideoClose}><CloseIcon
                                fontSize={"inherit"}/>
                            </div>
                        </div>
                    </Modal>
                )}
            </div>
            {open && (
                // <div className={"close-button"} onClick={handleClickClose}><a>✕</a></div>
                <>
                    <div className='ball-container ball-container-under'>
                        <div className={'ball-container-small'}>
                        <div className='ball ball-1'></div>
                        <div className='ball ball-2 ball-2-under' onClick={handleClickClose}></div>
                        </div>
                    </div>
                    <div className='ball-container text-overlay-container'>
                        <div className={'ball-container-small'}>
                        <div className='text-overlay ball ball-2'><a>✕</a></div>
                        </div>
                    </div>
                    <svg>
                        <filter id="gooey">
                            <feGaussianBlur in="SourceGraphic" stdDeviation="4"/>
                            <feColorMatrix values="1 0 0 0 0
                          0 1 0 0 0
                          0 0 1 0 0
                          0 0 0 18 -7"/>
                        </filter>
                    </svg>
                </>
            )}
        </>
    )
        ;
}

export default WorkSection;